import { roomTypeData } from "@/mock/room-type";

const getRoomType = (roomCount) => {
  const found = roomTypeData.find((item) => +Object.keys(item)[0] === +roomCount);
  return found ? found[roomCount] : null;
};

export const formatDetailData = (detailResult) => ({
  title: detailResult.name,
  id: detailResult.id,
  imagesFullPath: detailResult.images,
  videoUrl: detailResult.videoUrl,
  virtualTourUrl: detailResult.virtualTourUrl,
  location: {
    city: { name: detailResult.locationInfo?.city?.name },
    district: { name: detailResult.locationInfo?.district?.name },
    address: detailResult.locationInfo?.address,
    coordinate: detailResult.locationInfo?.poi?.coordinate,
  },
  priceDetail: {
    price:
      detailResult.price?.priceVisibility === "STARTCOUNT" ? detailResult.price?.startPrice : detailResult.price?.min,
    currency: detailResult.currency?.name || "TL",
    trendType: null,
    differenceRate: null,
    alternativeValue: null,
  },
  owner: {
    account: {
      phoneNumber: detailResult.company?.phoneNumber,
    },
  },
  breadcrumbs: [{ name: "", url: "" }],
  company: {
    id: detailResult.company?.id,
    name: detailResult.locationInfo?.city?.name,
    phone: detailResult.locationInfo?.phoneNumber,
    address: detailResult.locationInfo?.address,
    city: detailResult.locationInfo?.city?.id,
    district: detailResult.locationInfo?.district?.id,
  },
  property: detailResult.property,
  introText: detailResult.introText,
  about: detailResult.about,
  flatTypes: detailResult.flatTypes.map((flatType) => ({
    ...flatType,
    roomType: getRoomType(flatType.roomCount),
  })),
  salesStatus: detailResult.salesStatus,
  deliveryDate: detailResult.property?.deliveryDate,
  features: detailResult.property?.features,
  formData: {
    company: detailResult.company?.id || null,
    city: detailResult.locationInfo?.city.id || null,
    district: detailResult.locationInfo?.district.id || null,
    commissionEarnings: detailResult.company?.commissionEarnings || null,
    name: detailResult.company?.name || null,
    project: detailResult.id,
  },
  price: detailResult.price,
});
